<template>
  <div class="location-1">
    <button @click="getLocation" class="btn btn-primary rounded-pill location-1-btn" v-t="`tools.location.button`"/>
  </div>
</template>

<script>
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "Location1",
  data() {
    return {
      form: {
        latitude: null,
        longitude: null,
      }
    }
  },
  methods: {
    async storeUserLocation(lat, lon) {
      let form = {
        'lat': lat.toString(),
        'lon': lon.toString(),
      }
      await this.$store.dispatch('User/storeUserCoordinate', form).then(res => {

      }).catch(error => {
        console.log(error)
      })

    },
    getLocation() {

      if (navigator.geolocation) {

        navigator.geolocation.getCurrentPosition(async (position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          await this.storeUserLocation(this.latitude, this.longitude)

        }, (error) => {
          toast('مکان شما در دسترس نمیباشد', 'مکان شما در دسترس نمیباشد', 'danger')
        });
      } else {
        toast('موقعیت مکانی در دستگاه شما پشتیبانی نمیشود.', 'موقعیت مکانی در دستگاه شما پشتیبانی نمیشود.', 'danger')
      }
    },

  },
  mounted() {

    this.getLocation()

  }
}
</script>

<style scoped>

</style>